import { cx } from 'styled-system/css';
import { matchStyles } from '../match/match.style';
import { Market, SportMatchModel } from '@nf/types/odds';
import { scoreboardService } from '@/services/scoreboard.service';
import { Scoreboard, ScoreboardSportId } from '@/features/sportsbook-aside/components/scoreboard';
import { motion } from 'framer-motion';
import { MatchSpecialBetType, MatchSpecialCricketFancyContainer } from './match-special-bet-type';
import { MatchSpecialHeader } from './match-special-header/match-special-header';
import { MatchSpecialInfo } from './match-special-info/match-special-info';
import { matchSpecialStyles } from './match-special.style';
import { useOddsTableMarsContext } from '../../context';
import { MatchBaseBallAIOSpecial } from './match-special-bet-type/match-special-baseball-aio';

interface MatchSpecialProps {
	match: SportMatchModel;
	markets: Market[];
	isShowMatch: boolean;
	toggleMatch(): void;
	isLoading: boolean;
	homeTeamName: string;
	awayTeamName: string;
};

export const MatchSpecial = ({
	match,
	markets,
	isShowMatch,
	toggleMatch,
	isLoading,
	homeTeamName,
	awayTeamName
}: MatchSpecialProps) => {
	const { gameType, actStatus } = useOddsTableMarsContext();
	const { hasOtherScoreboard } = scoreboardService.getScoreboardInfo(match);

	return (
		<div className={cx('match', matchStyles.match)}>
			<MatchSpecialHeader match={match} showMatch={isShowMatch} toggleMatch={toggleMatch} />
			<MatchSpecialInfo match={match} markets={markets} isShowMatch={isShowMatch} toggleMatch={toggleMatch} />
			{
				actStatus && hasOtherScoreboard ?
					<Scoreboard
						key={`${match?.GameID}MatchInfoPanel`}
						sportId={match?.GameID as ScoreboardSportId}
						matchModelData={match}
					/> : null
			}
			<motion.div
				className={matchSpecialStyles.matchContent}
				initial="open"
				animate={isShowMatch ? 'open' : 'closed'}
				variants={{
					open: { height: 'auto', opacity: 1 },
					closed: { height: 0, opacity: 0 },
				}}
			>
				<div className={matchSpecialStyles.oddsTable}>
					{
						match.GameID === 8 ?
							(
								<MatchBaseBallAIOSpecial
									isLoading={isLoading}
									homeTeamName={homeTeamName}
									awayTeamName={awayTeamName}
									match={match}
									markets={markets}
									isShowMatch={isShowMatch}
								/>
							) :
							gameType === 'FC' ?
								(
									<MatchSpecialCricketFancyContainer
										match={match}
										markets={markets}
										isLoading={isLoading}
									/>
								)
								:
								(
									<MatchSpecialBetType
										isLoading={isLoading}
										homeTeamName={homeTeamName}
										awayTeamName={awayTeamName}
										match={match}
										markets={markets}
										isShowMatch={isShowMatch}
									/>
								)
					}
				</div>
			</motion.div>
		</div>
	);
}
